/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Maxattempts1Inputs */

const en__field_maxattempts1 = /** @type {(inputs: _Field_Maxattempts1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Max attempts`)
};

/**
* | output |
* | --- |
* | "Max attempts" |
*
* @param {_Field_Maxattempts1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const _field_maxattempts1 = /** @type {((inputs?: _Field_Maxattempts1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Maxattempts1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en__field_maxattempts1(inputs)
});
export { _field_maxattempts1 as "_field_maxAttempts" }